import { useContext } from 'react';

import { ToastContext } from '@/components/ui/toast-context';

/** Application-wide feedback for actions that succeed or fail. */
export function useToast() {
  const context = useContext(ToastContext);
  if (context === null) {
    throw new Error('useToast must be used inside <ToastProvider>');
  }
  return context;
}
